import { combineStorage } from '@atlassian/jira-common-storage-redux/src';
import type { State } from '../state/types';
import filter from './filter/storage';
import panel from './panel/storage';
import table from './table/storage';

export default combineStorage<State>(filter, table, panel);
